<template>
	<b-form-group class="labeled-select" :label="label" :id="id" :class="cssClass">
		<blumar-multiselect :label="textField || 'name'" :trackBy="idField || 'id'" :id="selectId"
			:value="value" @input="$emit('input', $event)"
			v-bind="$props" v-on="$listeners">
			<slot>
			</slot>
		</blumar-multiselect>
	</b-form-group>
</template>

<script>
import BlumarMultiSelect from './BlumarMultiSelect.vue';
export default {
	extends: BlumarMultiSelect,
	props: ['textField', 'idField', 'id', 'cssClass', 'label'],
	computed: {
		selectId() {
			if (this.id)
				return this.id + '-select';
		}
	}
}
</script>

<style lang="scss">
.labeled-select {
	legend {
		font-weight: bold;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/LabeledSelect.vue